module.exports = __webpack_public_path__ + "img/giveaway.aef2e906.png";